import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'
import { Avatar } from '@wartek-id/avatar'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useSETrackEvent } from 'app/Homepage/hooks/useSETrackEvent'
import { useAuth } from 'utils/auth'

const ProfileDropdown = () => {
  const { session, login, logout } = useAuth()
  const { SETrackClickViewProfile } = useSETrackEvent()
  const router = useRouter()
  const [isLoggingOut, setIsLoggingOut] = React.useState(false)
  const isLoggedIn = !!session
  const user = session?.user

  if (!isLoggedIn) {
    return (
      <Button
        color="white"
        size="md"
        onClick={() => {
          login()
        }}
        className="!text-[#2A7EFB]"
      >
        Masuk
      </Button>
    )
  }

  const email = user?.loginEmail || user?.email || ''
  const profileHref = `/profil/${user?.id}?from=${encodeURIComponent(
    router.asPath
  )}`

  return (
    <Popover onClose={() => {}} onOpen={() => {}} placement="bottom-end">
      <PopoverTrigger
        as="button"
        className="cursor-pointer p-0 m-0 border-none bg-transparent flex items-center h-[38px]"
      >
        <div className="flex h-full items-center justify-center gap-2">
          <Avatar
            src={user?.picture}
            name={user?.name || 'User'}
            size="lg"
            alt="Avatar"
          />
          <Icon aria-hidden="true" color="inverse">
            expand_more
          </Icon>
        </div>
      </PopoverTrigger>
      <PopoverContent className="mt-2 min-w-[300px] rounded-lg shadow-lg">
        <div className="flex flex-col">
          {/* Header */}
          <div className="flex flex-col items-center justify-center p-6 border-b border-subdued">
            <Avatar
              src={user?.picture}
              name={user?.name || 'User'}
              size="xxl"
              alt="Avatar"
            />
            <Text variant="heading-md" className="mt-4 text-center">
              {user?.name || 'User'}
            </Text>
            <Text
              variant="body-sm"
              color="disabled"
              className="mt-1 text-center"
            >
              {email}
            </Text>
          </div>

          {/* Links */}
          <div className="flex flex-col py-2">
            <Link href={profileHref} passHref>
              <Button
                fullWidth
                as="a"
                variant="ghost"
                color="black"
                className="!justify-start rounded-none px-6 py-3 font-normal"
                onClick={SETrackClickViewProfile}
              >
                Lihat profil saya
              </Button>
            </Link>
            <Button
              fullWidth
              as="a"
              href={`${process.env.NEXT_PUBLIC_PUSAT_INFORMASI_RUMDIK_BASE_URL}/hc/id/categories/44586577246105-Ruang-GTK`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              color="black"
              className="!justify-start rounded-none px-6 py-3 font-normal"
            >
              Pusat Bantuan
            </Button>
            <Link href="/policy" passHref>
              <Button
                fullWidth
                as="a"
                variant="ghost"
                color="black"
                className="!justify-start rounded-none px-6 py-3 font-normal"
              >
                Kebijakan Privasi
              </Button>
            </Link>
            <Link href="/tns" passHref>
              <Button
                fullWidth
                as="a"
                variant="ghost"
                color="black"
                className="!justify-start rounded-none px-6 py-3 font-normal"
              >
                Persyaratan Layanan
              </Button>
            </Link>
          </div>

          {/* Logout */}
          <div className="py-4 border-t border-subdued">
            <Button
              variant="ghost"
              color="black"
              className="!justify-start px-2 py-2 font-semibold"
              disabled={isLoggingOut}
              onClick={async () => {
                try {
                  setIsLoggingOut(true)
                  await logout()
                } catch (error) {
                  console.error('Error during logout', error)
                  setIsLoggingOut(false)
                }
              }}
              fullWidth
            >
              Keluar
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default ProfileDropdown
